import { RegistrationProgress } from '@/components/ProgressBar/RegistrationProgress'
import useAccessStore from '@/store/accessStore'
import { useNavigate } from 'react-router-dom'
import { RegistrationUploadLogoForm } from './RegistrationUploadLogoForm'
import styles from './registration.module.css'

export const RegistrationUploadLogo = () => {
  const navigate = useNavigate()
  const { fetchBrandData } = useAccessStore()

  async function handleFinish(_file: File | null, dataUrl?: string) {
    try {
      const { default: brandUserService } = await import('@/services/brandUserService')

      let blob: Blob | null = null
      if (dataUrl) {
        const res = await fetch(dataUrl)
        blob = await res.blob()
      }

      if (!blob) {
        navigate('/registration/account-ready')
        return
      }

      const file = new File([blob], 'logo.png', { type: blob.type || 'image/png' })
      await brandUserService.uploadBrandLogo(file)
      await fetchBrandData()

      navigate('/registration/account-ready')
    } catch (e) {
      console.error('Logo upload failed', e)
      alert('Failed to upload logo. Please try again.')
    }
  }

  const handleBack = async () => {
    await fetchBrandData()
    navigate('/registration/business')
  }

  return (
    <>
      <div className={styles.mainContentWrapper} style={{ maxWidth: 579 }}>
        <h1 className={styles.title}>Upload Your Logo</h1>
        <p className={styles.textGrey}>Add your company logo to personalize your profile and enhance brand recognition.</p>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 24 }}>
          <RegistrationProgress />
        </div>
        <RegistrationUploadLogoForm onBack={handleBack} onFinish={handleFinish} />
      </div>
    </>
  )
}
